import React from "react";
import closeImg from "../assets/images/closeimg.png";

interface GenericModalProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  width?: string;
}

const GenericModal: React.FC<GenericModalProps> = ({
  isOpen,
  title,
  onClose,
  children,
  width,
}) => {
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.35)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          background: "#fff",
          borderRadius: "24px",
          boxShadow: "0 10px 35px rgba(0,0,0,0.18)",
          width: width ? width : "fit-content",
          maxWidth: "95%",
          overflow: "hidden",
          paddingRight: "20px",
          paddingLeft: "20px",
        }}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            border: "none",
            background: "#E8F5FF",
            borderRadius: "12px",
            padding: "8px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={closeImg}
            alt="close"
            style={{
              width: "24px",
              height: "24px",
              display: "block",
            }}
          />
        </button>

        {/* Header */}
        <div
          style={{
            padding: "20px 0px",
            borderBottom: "2px solid #EAEAEA",

            paddingTop: "23px",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "24px",
              fontWeight: 600,
              color: "#2D2D2D",
              fontFamily: "Mazzard",
            }}
          >
            {title}
          </h2>
        </div>

        {/* Body */}
        <div
          style={{
            padding: "20px 0px",
            paddingTop: "10px",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default GenericModal;
